import { EmailInput } from "../../../../utils/form";

const UserEmailInput = (props) => (
  <EmailInput
    {...props}
    required
    fullWidth
    helperText={props.bgColor ? "" : "Como se mostrará en las prescripciones"}
    placeholder="Ej: nombre@email.com"
    sx={{ backgroundColor: props.bgColor && "#F2F9FF66" }}
  />
);

export default UserEmailInput;
